import React, { Component } from "react";
import "../../css/AiRpCommonAssets.css";
import "../../css/AiRpFreeTrial.css";

import http from "../modules/api";
import { da } from "date-fns/locale";

class AiRpFreeTrial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      installList: [],
    };
  }

  componentDidMount() {
    this.fetchDashboard();
    this.fetchInstallList();
  }

  fetchDashboard = () => {
    http.get("/rest/shop/ai/rp/stats", {
      params: {
        is_group_by_iframe_page_id: true,
        s: "1900-01-01", // start,
        e: "2999-12-31", // end,
      }
    })
    .then(res => {
      // 서버가 Map으로 내려준 구조 그대로 저장
      this.setState({
        dashboard: res.data,
      });
    })
    .catch(err => {
      this.setState({ loading: false, sync: false });
      alert("추천 성과 조회 에러");
    });
  };

  /**
   * 설치 페이미 목록 조회
   */
  fetchInstallList = () => {
    http.get("/rest/shop/ai/rp/installListByPageId", {
      params: {}
    })
    .then(res => {
      // 서버가 Map으로 내려준 구조 그대로 저장
      this.setState({
        installList: res.data.install_list ? res.data.install_list : [],
      });
    })
    .catch(err => {
      this.setState({ loading: false, sync: false });
      alert("설치 페이미 목록 조회 에러");
    });
  };

  /**
   * 숫자 포맷
   */
  formatNumber = (v) => {
    if (v == null) return '0';
    const n = Number(v);
    if (isNaN(n)) return String(v);
    return n.toLocaleString('ko-KR');
  };

  /**
   * 증감 상태(up/down/same) 만들기
   * - 예: 매출 증감률 rev_chg_pct 를 사용
   */
  buildChgStatus = (pct) => {
    const n = Number(pct);
    if (!isFinite(n) || isNaN(n)) return { status: 'same', rate: 0 };
    if (n > 0) return { status: 'up', rate: n };
    if (n < 0) return { status: 'down', rate: n };
    return { status: 'same', rate: 0 };
  };

  render() {
    const { dashboard, installList } = this.state;

    // KPI 가공
    const kpi = dashboard && dashboard.kpi ? dashboard.kpi : null;

    const cur_pv = kpi ? kpi.cur_pv : 0;
    const cur_imp = kpi ? kpi.cur_imp : 0;
    const cur_click = kpi ? kpi.cur_click : 0;

    // 주문/매출은 “구매일 기준 + last-click 7일”로 채운 order_cnt/order_amount
    const cur_order = kpi ? kpi.cur_order : 0;
    const cur_rev = kpi ? kpi.cur_rev : 0;

    // CTR/CVR
    const cur_ctr_pct = kpi ? kpi.cur_ctr_pct : 0;
    const cur_cvr_pct = kpi ? kpi.cur_cvr_pct : 0;

    const revChgPct = kpi ? kpi.rev_chg_pct : 0;
    const revChg = this.buildChgStatus(revChgPct);

    const orderStatsDaily = dashboard && dashboard.orderStatsDaily ? dashboard.orderStatsDaily : null;

    const total_order_amount = orderStatsDaily ? orderStatsDaily.total_order_amount ? orderStatsDaily.total_order_amount : 0 : 0;

    // 도달률(= imp/pv)
    const reachPct = (Number(cur_pv) > 0) ? (Number(cur_imp) / Number(cur_pv) * 100) : 0;

    // Slot Table
    const slotTable = dashboard && dashboard.slotTable ? dashboard.slotTable : [];

    const robomd_detail_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_detail_page")?.cvr_pct || 0;
    const robomd_main_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_main_page")?.cvr_pct || 0;
    const robomd_order_complete_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_order_complete_page")?.cvr_pct || 0;
    const robomd_cart_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_cart_page")?.cvr_pct || 0;

    const is_robomd_ai_main_page_use = installList.some(
      slot => slot.iframe_page_id === "robomd_ai_main_page"
    );

    const is_robomd_ai_cart_page_use = installList.some(
      slot => slot.iframe_page_id === "robomd_ai_cart_page"
    );

    const is_robomd_ai_order_complete_page_use = installList.some(
      slot => slot.iframe_page_id === "robomd_ai_order_complete_page"
    );

    const is_robomd_ai_detail_page_use = installList.some(
      slot => slot.iframe_page_id === "robomd_ai_detail_page"
    );    

    return (
      <div id="common-page-wrapper">
        <div className="ai-rp-free-trial">
          <div className="layout-wrapper">
            <main className="main-content">
              <div className="container">
                <div className="page-header">
                  <h1>
                    무료 체험이 진행 중입니다!
                  </h1>
                  <p>
                    가입이 완료되었습니다. 쇼핑몰회원과 비회원의 체류활동까지 수집되는 AI 추천을 적용하여 2주간 무료로 성과를 확인해보세요.
                  </p>
                </div>
                <section className="card metrics-card">
                  <div className="metrics-header">
                    <div>
                      <h2>
                        <div className="live-dot-small"></div>
                        AI추천 성과
                      </h2>
                      <p>
                        무료 체험 시작 이후 현재까지 수집된 고객님의 쇼핑몰 AI 추천 라이브 성과입니다.
                      </p>
                    </div>
                    <button className="btn-more" onClick={() => { window.open("/shop/ai/rp/dashboard", "_blank") }}>
                      성과 상세 분석 더보기
                      <i className="fa-solid fa-chevron-right"></i>
                    </button>
                  </div>
                  <div className="metrics-grid">
                    <div className="metric-item">
                      <p className="metric-label">
                        현재 누적 페이지뷰
                      </p>
                      <p className="metric-value num-font">
                        {this.formatNumber(cur_pv)}
                        <span className="metric-unit">
                          뷰
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        현재 실 노출수
                      </p>
                      <p className="metric-value num-font">
                        {this.formatNumber(cur_imp)}
                        <span className="metric-unit">
                          건
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        현재 클릭수
                      </p>
                      <p className="metric-value num-font">
                        {this.formatNumber(cur_click)}
                        <span className="metric-unit">
                          건
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        현재 구매건수
                      </p>
                      <p className="metric-value num-font">
                        {Number(cur_click) === 0 ? 0 : this.formatNumber(cur_order)}
                        <span className="metric-unit">
                          건
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        기여 매출액
                      </p>
                      <p className="metric-value highlight num-font">
                        ₩ {Number(cur_click) === 0 ? 0 : this.formatNumber(cur_rev)}
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        기여 매출율
                      </p>
                      <p className="metric-value highlight num-font">
                        {this.formatNumber(
                          Number(total_order_amount) === 0 || Number(cur_click) === 0
                            ? 0
                            : (Number(cur_rev) / Number(total_order_amount) * 100).toFixed(2),
                          2
                        )}
                        <span className="metric-unit">
                          %
                        </span>
                      </p>
                    </div>
                  </div>
                </section>
                <section className="card status-banner">
                  <div className="status-left">
                    <div className="radar-box">
                      <div className="radar-wave"></div>
                      <i className="fa-solid fa-satellite-dish"></i>
                    </div>
                    <div className="status-text">
                      <h2>
                        AI타겟뷰 앱 연동 완료 — 방문자 활동 수집 중
                        <span className="badge-success">
                          설치 완료
                        </span>
                      </h2>
                      <p>
                        방문자의 상품 클릭, 체류시간, 관심 카테고리, 재방문 여부 등을 실시간으로 분석해
                        <strong style={{marginLeft: "4px"}}>
                          AI추천의 비회원 추천 정확도 향상에 사용됩니다.
                        </strong>
                      </p>
                    </div>
                  </div>
                  <div className="status-right">
                    <div className="live-badge">
                      <div className="live-dot"></div>
                      실시간 수집 중
                    </div>
                  </div>
                </section>
                <section>
                  <h2 className="section-title">
                    작동 중인 AI 추천 영역
                  </h2>
                  <div className="widget-grid">
                    <div className={"widget-card" + (is_robomd_ai_detail_page_use ? " active" : "")}>
                      <div className="w-header">
                        <div className="w-icon w-icon-1">
                          <i className="fa-regular fa-file-lines"></i>
                        </div>
                      </div>
                      <div>
                        <h3 className="w-title">
                          상품 상세 (Item-Based CF)
                        </h3>
                        <p className="w-desc">
                          "이 상품을 본 고객이 함께 산 상품"을 딥러닝으로 매칭하여 추가 구매를 유도합니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            누적 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            {robomd_detail_page_cur_cvr_pct ? this.formatNumber(robomd_detail_page_cur_cvr_pct, 2) : 0}%
                          </span>
                        </div>
                        {
                          is_robomd_ai_detail_page_use ? (
                            <div className="status-badge-running">
                              <div className="live-dot-small" style={{"width": "4px", "height": "4px"}}></div>
                              작동중
                            </div>
                          ) : (
                            <button className="btn-install" onClick={() => { window.location.href = "/shop/ai/rp/algorithmList?filter_iframe_page_id=robomd_ai_detail_page"; }}>
                              설치요청
                            </button>
                          )
                        }
                      </div>
                    </div>
                    <div className={"widget-card" + (is_robomd_ai_cart_page_use ? " active" : "")}>
                      <div className="w-header">
                        <div className="w-icon w-icon-2">
                          <i className="fa-solid fa-cart-shopping"></i>
                        </div>
                      </div>
                      <div>
                        <h3 className="w-title">
                          장바구니 (Cross-Sell)
                        </h3>
                        <p className="w-desc">
                          장바구니 상품과 연관성이 높은 아이템을 제안하여 동시 구매율을 높입니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            누적 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            {robomd_cart_page_cur_cvr_pct ? this.formatNumber(robomd_cart_page_cur_cvr_pct, 2) : 0}%
                          </span>
                        </div>
                        {
                          is_robomd_ai_cart_page_use ? (
                            <div className="status-badge-running">
                              <div className="live-dot-small" style={{"width": "4px", "height": "4px"}}></div>
                              작동중
                            </div>
                          ) : (
                            <button className="btn-install" onClick={() => { window.location.href = "/shop/ai/rp/algorithmList?filter_iframe_page_id=robomd_ai_cart_page"; }}>
                              설치요청
                            </button>
                          )
                        }
                      </div>
                    </div>
                    <div className={"widget-card" + (is_robomd_ai_order_complete_page_use ? " active" : "")}>
                      <div className="w-header">
                        <div className="w-icon w-icon-3">
                          <i className="fa-solid fa-circle-check"></i>
                        </div>
                      </div>
                      <div>
                        <h3 className="w-title">
                          구매완료 (재구매 유도)
                        </h3>
                        <p className="w-desc">
                          결제 직후 고객의 취향을 분석해 다음 방문 시 구매할 가능성이 높은 상품을 노출합니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            누적 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            {robomd_order_complete_page_cur_cvr_pct ? this.formatNumber(robomd_order_complete_page_cur_cvr_pct, 2) : 0}%
                          </span>
                        </div>
                        {
                          is_robomd_ai_order_complete_page_use ? (
                            <div className="status-badge-running">
                              <div className="live-dot-small" style={{"width": "4px", "height": "4px"}}></div>
                              작동중
                            </div>
                          ) : (
                            <button className="btn-install" onClick={() => { window.location.href = "/shop/ai/rp/algorithmList?filter_iframe_page_id=robomd_ai_order_complete_page"; }}>
                              설치요청
                            </button>
                          )
                        }
                      </div>
                    </div>
                    <div className={"widget-card" + (is_robomd_ai_main_page_use ? " active" : "")}>
                      <div className="w-header">
                        <div className="w-icon w-icon-4">
                          <i className="fa-solid fa-house"></i>
                        </div>
                      </div>
                      <div>
                        <h3 className="w-title">
                          메인 홈 (Best Seller)
                        </h3>
                        <p className="w-desc">
                          방문자의 관심 키워드와 연관된 상품을 분석하여 가장 구매 확률이 높은 상품을 보여줍니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            누적 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            {robomd_main_page_cur_cvr_pct ? this.formatNumber(robomd_main_page_cur_cvr_pct, 2) : 0}%
                          </span>
                        </div>
                        {
                          is_robomd_ai_main_page_use ? (
                            <div className="status-badge-running">
                              <div className="live-dot-small" style={{"width": "4px", "height": "4px"}}></div>
                              작동중
                            </div>
                          ) : (
                            <button className="btn-install" onClick={() => { window.location.href = "/shop/ai/rp/algorithmList?filter_iframe_page_id=robomd_ai_main_page"; }}>
                              설치요청
                            </button>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </section>
                <section className="card onboarding-card">
                  <div className="step-container">
                    <div className="step-line"></div>
                    <div className="step-line-active" style={{"width": "60%"}}></div>
                    <div className="step-item active">
                      <div className="step-circle">
                        <i className="fa-solid fa-check"></i>
                      </div>
                      <div className="step-name">
                        회원 가입
                      </div>
                    </div>
                    <div className="step-item active">
                      <div className="step-circle">
                        <i className="fa-solid fa-check"></i>
                      </div>
                      <div className="step-name">
                        AI타겟뷰 앱 설치
                      </div>
                    </div>
                    <div className="step-item active">
                      <div className="step-circle">
                        <i className="fa-solid fa-check"></i>
                      </div>
                      <div className="step-name">
                        AI 추천 설치 완료
                      </div>
                    </div>
                    <div className="step-item current">
                      <div className="step-circle num-font">
                        4
                      </div>
                      <div className="step-name">
                        무료 체험 중
                      </div>
                    </div>
                    <div className="step-item">
                      <div className="step-circle num-font">
                        5
                      </div>
                      <div className="step-name">
                        도입 결정
                      </div>
                    </div>
                  </div>
                  <div className="action-area">
                    <button className="btn-action-install" onClick={() => { window.open("/shop/ai/rp/dashboard", "_blank") }}>
                      <i className="fa-solid fa-chart-line"></i>
                      AI추천 성과 확인하기
                    </button>
                    <p className="helper-text">
                      매시 정각에 현재까지의 최신 데이터가 업데이트 됩니다.
                      <br />
                      AI가 더 많은 고객 행동을 학습할수록
                      <strong style={{marginLeft: "4px"}}>
                        추천 정확도와 구매 전환율은 지속적으로 상승합니다.
                      </strong>
                    </p>
                  </div>
                </section>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

export default AiRpFreeTrial;
